module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('modal', {
    attrs: {
      "size": "small"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Etes vous sûr de customiser ce joueur avec les éléments suivants ?")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('div', {
    staticClass: "large-12 columns"
  }, [(_vm.visibilities.stats) ? [_c('table', [_c('thead', {
    staticClass: "roster-head"
  }, [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Modification de stats")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "large-font"
  }, [(_vm.customisations.M !== 0) ? _c('tr', [_c('td', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("M.")]), _vm._v(" "), _c('td', {
    staticClass: "stat",
    attrs: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.customisations.M))])]) : _vm._e(), _vm._v(" "), (_vm.customisations.F !== 0) ? _c('tr', [_c('td', [_vm._v("F.")]), _vm._v(" "), _c('td', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.customisations.F))])]) : _vm._e(), _vm._v(" "), (_vm.customisations.Ag !== 0) ? _c('tr', [_c('td', [_vm._v("Ag.")]), _vm._v(" "), _c('td', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.customisations.Ag))])]) : _vm._e(), _vm._v(" "), (_vm.customisations.Ar !== 0) ? _c('tr', [_c('td', [_vm._v("Ar.")]), _vm._v(" "), _c('td', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.customisations.Ar))])]) : _vm._e()])])] : _vm._e(), _vm._v(" "), (_vm.visibilities.free_xp) ? [_c('table', [_c('thead', {
    staticClass: "roster-head"
  }, [_c('tr', [_c('th', [_vm._v("Xp gratuits")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "large-font"
  }, [_c('td', {}, [_vm._v(_vm._s(_vm.customisations.free_xp) + " xp")])])])] : _vm._e(), _vm._v(" "), (_vm.visibilities.skills) ? [_c('table', [_c('thead', {
    staticClass: "roster-head"
  }, [_c('tr', [_c('th', [_vm._v("Compétence Additionnelles")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "large-font"
  }, _vm._l((_vm.customisations.skills), function(skill) {
    return _c('tr', [_c('td', {
      staticClass: "stat"
    }, [_vm._v(_vm._s(_vm.getSkillName(skill)))])])
  }), 0)])] : _vm._e(), _vm._v(" "), (_vm.visibilities.xp) ? [_c('table', [_c('thead', {
    staticClass: "roster-head"
  }, [_c('tr', [_c('th', {
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("Nouvelles Actions à Xp")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "large-font"
  }, [_c('tr', [_c('td', [_vm._v("Reu.")]), _vm._v(" "), _c('td', [_vm._v("Td.")]), _vm._v(" "), _c('td', [_vm._v("Int.")]), _vm._v(" "), _c('td', [_vm._v("Sor.")]), _vm._v(" "), _c('td', [_vm._v("Mvp.")]), _vm._v(" "), _c('td', [_vm._v("Bls.")]), _vm._v(" "), _c('td', [_vm._v("Aggro.")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.customisations.nb_pass))]), _vm._v(" "), _c('td', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.customisations.nb_td))]), _vm._v(" "), _c('td', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.customisations.nb_int))]), _vm._v(" "), _c('td', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.customisations.nb_cas))]), _vm._v(" "), _c('td', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.customisations.nb_mvp))]), _vm._v(" "), _c('td', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.customisations.nb_foul))]), _vm._v(" "), _c('td', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.customisations.nb_niggling))])])])])] : _vm._e(), _vm._v(" "), [_c('table', [_c('thead', {
    staticClass: "roster-head"
  }, [_c('tr', [_c('th', [_vm._v("Impact sur le coût du joueur & TV de l'équipe")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "large-font"
  }, [_c('tr', [_c('td', {
    staticClass: "stat"
  }, [_vm._v(_vm._s(_vm.customisations.additionnal_cost) + " 000 pO")])])])])]], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "row columns"
  }, [_c('button', {
    staticClass: "large-4 light-grey-button",
    on: {
      "click": function($event) {
        return _vm.$emit('closeMessage')
      }
    }
  }, [_vm._v("Annuler")]), _vm._v(" "), _c('button', {
    staticClass: "large-4 large-offset-2 alert",
    on: {
      "click": function($event) {
        return _vm.$emit('confirm')
      }
    }
  }, [_vm._v("Confirmer")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38042a35"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/team/team-customize-modals/customisation-confirm-modal.vue
// module id = 733
// module chunks = 0